// src/components/Hero.jsx
import React from 'react';
import Testimonials from './Testimonials';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightToBracket } from '@fortawesome/free-solid-svg-icons';

export default function Hero() {
  return (
    <section className="hero-section">
      <div className="container d-flex flex-column flex-lg-row align-items-center justify-content-between">
        <div className="hero-content text-center text-lg-start">
          <h1 className="hero-title">
            Meer klanten via <span className="text-orange">online zichtbaarheid</span>
          </h1>
          <p className="hero-subtitle">
            OnlineGrowthClub.nl helpt jouw bedrijf groeien met websites,
            SEO, social media en slimme advertenties.
          </p>

          {/* Desktop CTA */}
          <a
            href="/contact"
            className="btn btn-orange btn-lg d-none d-lg-inline-flex align-items-center"
          >
            <FontAwesomeIcon icon={faArrowRightToBracket} className="me-2" />
            Ontvang gratis groeiscan
          </a>
        </div>

        <div className="testimonial-wrapper mt-5 mt-lg-0">
          <Testimonials />
        </div>
      </div>

      {/* Mobile CTA below testimonials */}
      <div className="text-center mt-4 d-lg-none">
        <a href="/contact" className="btn btn-orange btn-lg align-items-center">
          <FontAwesomeIcon icon={faArrowRightToBracket} className="me-2" />
          Ontvang gratis groeiscan
        </a>
      </div>
    </section>
  );
}
